import React from 'react';
import { Typography } from "../common/Typography";
import { defineStyles } from '@/components/hooks/defineStyles';
import { useStyles } from '@/components/hooks/useStyles';

const styles = defineStyles('SunshineListTitle', (theme: ThemeType) => ({
  root: {
    borderTop: theme.palette.border.normal,
    padding: 12,
    fontWeight: 600,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  }
}))

const SunshineListTitle = ({children}: {
  children: React.ReactNode,
}) => {
  const classes = useStyles(styles);

  return <Typography variant="body2" className={classes.root}>
    { children }
  </Typography>
};

export default SunshineListTitle;



